import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IOAuthClient } from '../types/IOAuthClient';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetOAuthClientsResult extends IGetItemsResult {
  oauthClients: IOAuthClient[];
}

export class GetOAuthClientsRequest extends Request<IGetItemsParams, IGetOAuthClientsResult> {
  constructor(params: IGetItemsParams) {
    super('getOAuthClients', params);
  }
}
